"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBSITE_HOST = exports.ALLOWED_QUERIES = exports.UNORDERED_ITEM_POSITION = exports.TEMPLATE_WRAPPER_CLASSNAME = exports.VARY_HEADER = exports.CACHE_CONTROL_HEADER = exports.PUBLIC_SUBMISSIONS_PAGE_SIZE = exports.QS_STRINGIFY_OPTIONS = void 0;
exports.QS_STRINGIFY_OPTIONS = { arrayFormat: 'comma', skipNulls: true };
exports.PUBLIC_SUBMISSIONS_PAGE_SIZE = 24; // 24
var DAY = 60 * 60 * 24;
var MINUTE = 60 * 1;
var CACHE_VALUE = process.env.ENV === 'production' ? 1 * DAY : 10 * MINUTE;
exports.CACHE_CONTROL_HEADER = "public, max-age=".concat(CACHE_VALUE, ", s-maxage=").concat(CACHE_VALUE);
exports.VARY_HEADER = 'origin, accept-encoding';
exports.TEMPLATE_WRAPPER_CLASSNAME = 'template-wrapper';
exports.UNORDERED_ITEM_POSITION = 999999999;
exports.ALLOWED_QUERIES = [
    'query',
    'page',
    'limit',
    'offset',
    'filters',
    'sCh',
    'pId',
    'partner',
    'referrer',
    'tagName',
    'utm_source',
    'utm_medium',
    'utm_campaign',
];
var WEBSITE_HOST = '';
exports.WEBSITE_HOST = WEBSITE_HOST;
switch (process.env.ENV) {
    case 'production':
        exports.WEBSITE_HOST = WEBSITE_HOST = 'https://smbcover.ynet.co.il';
        break;
    case 'development':
        exports.WEBSITE_HOST = WEBSITE_HOST = "https://".concat(process.env.PROJECT_ID, ".firebaseapp.com");
        break;
    case 'local':
    default:
        exports.WEBSITE_HOST = WEBSITE_HOST = "http://localhost:".concat(process.env.WEBSITE_DEV_PORT);
        break;
}
//# sourceMappingURL=other.js.map